import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, filter, map, includes } from "lodash";

import Box from "@material-ui/core/Box";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";

import AddDriveInOutDialog from "./AddDriveInOutDialog";

import { getLov } from "../../../utils/lov";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

import { LOG_EVENT_GROUP_TYPES } from "../../../constants/logEventGroupTypes";
import { driveInOut } from "../../../constants/reducers";

const styles = {
  menuItem: {
    padding: "15px 20px",
    fontSize: "1em",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  itemIcon: {
    width: "35px",
    minWidth: "unset",
    marginRight: "15px",
  },
};

const AddDriveInOut = (props) => {
  const { classes, language } = props;
  const [open, setOpen] = React.useState(false);
  const [lov, setLov] = React.useState({});
  const [eventGroupType, setEventGroupType] = React.useState();
  const [anchorEl, setAnchorEl] = React.useState(null);

  React.useEffect(() => {
    const fetchEventGroupTypes = async () => {
      try {
        let eventGroupTypes = await getLov("eventGroupTypes");
        eventGroupTypes = filter(eventGroupTypes, (t) =>
          includes(get(LOG_EVENT_GROUP_TYPES, driveInOut), t.id)
        );
        setLov({
          eventGroupTypes,
        });
      } catch (e) {
        console.log(e);
      }
    };
    fetchEventGroupTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <>
      <Box style={{ padding: "27px 30px 0px 0px" }}>
        <img
          src={images.plusIconColored}
          alt="add"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          style={{ cursor: "pointer" }}
          aria-controls="simple-menu"
          aria-haspopup="true"
        />
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          getContentAnchorEl={null}
        >
          {map(get(lov, ["eventGroupTypes"]), (type, index) => (
            <MenuItem
              key={index}
              classes={{ root: classes.menuItem }}
              alignItems="center"
              onClick={() => {
                setAnchorEl(null);
                setEventGroupType(type);
                setOpen(true);
              }}
              style={{ paddingLeft: "0px !important" }}
            >
              <ListItemIcon
                classes={{ root: classes.itemIcon }}
                style={{ display: "flex", justifyContent: "center" }}
              >
                {includes(get(LOG_EVENT_GROUP_TYPES, driveInOut), type.id) && (
                  <img
                    src={
                      type.id === 2
                        ? images.driveInIcon
                        : type.id === 3
                        ? images.driveOutIcon
                        : null
                    }
                    height="20px"
                    style={{ maxWidth: "35px" }}
                    alt="event_icon"
                  />
                )}
              </ListItemIcon>
              {type[`name_${language}`]}
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <AddDriveInOutDialog
        open={open}
        closeDialog={closeDialog}
        eventGroupType={eventGroupType}
      />
    </>
  );
};

export default withStyles(styles)(AddDriveInOut);
